import { ServicePage } from './ServicePage';
import { CreditCard } from 'lucide-react';

const PaymentsPage = () => {
  return <ServicePage serviceKey="payments" icon={CreditCard} />;
};

export default PaymentsPage;
